
import { Component, Prop, Vue } from 'vue-property-decorator';
// @ts-expect-error:
import auth from '@platform/authentication';
// @ts-expect-error:
import customerDataService from '@platform/customer-data-service';
import { logger } from 'logs-api-client';
import { IUser } from '@/types/user';
import ModalActivate2FA from './ModalActivate2FA.vue';
import PasswordModal from './PasswordModal.vue';

@Component({
  components: {
    ModalActivate2FA,
    PasswordModal,
  },
})
export default class TabChangePassword extends Vue {
  @Prop({
    required: true,
    default: 'my-account',
    type: String,
  }) readonly activeTab!: string;

  @Prop({
    required: true,
    default: () => ({}),
    type: Object,
  }) readonly user!: IUser;

  public loading = false;

  public passwordStrength = '';

  public hasPasswordVisible = false;

  public invalidPassword = false;

  public newPassword = '';

  public passwordHistory = process.env.VUE_APP_PASSWORD_HISTORY;

  public isBlocked = false;

  public showPasswordModal = false;

  public twoFactorEnabled = false;

  public show2FaModal = false;

  mounted() {
    this.twoFactorEnabled = this.isZenviaEmail(this.user.email) || this.user.requireMfa;
  }

  public async onTwoFactorToggle(event: Event) {
    const target = event.target as HTMLInputElement;
    const isEnabled = target.checked;

    if (isEnabled) {
      this.show2FaModal = true;
    }
  }

  public closePasswordModal() {
    this.showPasswordModal = false;
  }

  public openPasswordModal() {
    this.showPasswordModal = true;
  }

  async created() {
    await this.fetchPlanStatus();
  }

  private async fetchPlanStatus() {
    try {
      const context = await customerDataService.getContext();
      this.isBlocked = context.planStatus === 'BLOCKED';
    } catch (error: any) {
      logger.error(`${error}`, error);
    }
  }

  public close2FaModal() {
    this.twoFactorEnabled = false;
    this.show2FaModal = false;
  }

  public async onActivate2FA() {
    this.show2FaModal = false;
    await auth.logout();
  }

  public isZenviaEmail(email:string) {
    const zenviaEmailRegex = /^[a-zA-Z0-9._%+-]+@zenvia\.com$/;
    return zenviaEmailRegex.test(email);
  }
}
